import '@babel/polyfill'
import babelPolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import VueHtmlToPaper from 'vue-html-to-paper';
import VueHtml2Canvas from 'vue-html2canvas';


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options);
Vue.use(VueHtml2Canvas);
Vue.component('apex-chart', VueApexCharts)


axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';


Vue.config.productionTip = false

Vue.use(VueAxios, axios)


Vue.filter('two_digits', function (value) {
  if(value.toString().length <= 1)
  {
    return "0"+value.toString();
  }
  return value.toString();
});


Vue.filter('decimals', function (value) {
  return Number.parseFloat(value).toFixed(2);
});

Vue.filter('rounded', function (value) {
  return Math.round(Number.parseFloat(value));
});

Vue.filter('ellipsis', function (value) {
  if( value && value.length > 15 ){
    return value.slice(0,15) + '...';
  }else{
    return value;
  }
});

Vue.filter('array_text', function (value) {
  if(!value) { return }
  let arrtext = [];
  console.log(value);

  value.forEach( v => {
    console.log(v);
    arrtext.push(v.name);
  })

  return arrtext.join(', ')
});

router.beforeEach((to, from, next) => {
  if(to.path == '/register-code'){
      next();
  }else if(to.path == '/register'){
    console.log('Token validating: ',to.query.token);
    if(to.query.token){
      next();
    }else{
      console.log('Redirect to login, Missing token');
      next({ name:'login'});
    }
  }else if(localStorage.user || to.path == '/login'){
    console.log('logged');

    if(to.path == '/'){
      console.log('Redirect to profile')
      next({ name:'profile'});
    }else{
      next();
    }
  }else if(to.path !== '/login'){
    console.log('Redirect to login')
    next({ name:'login'});
  }else{
    next();
  }

})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
